import React, { useState } from 'react';
import { IoChevronDownSharp } from "react-icons/io5";

const CustomCheckboxDropdown = ({ options, name, value, onChange, placeholder, disabled, dropdownOpen, setDropdownOpen, width = '20rem' }) => {
    // const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const handleCheckboxChange = (e) => {
        const newValue = [...value];
        if (e.target.checked) {
            newValue.push(e.target.value);
        } else {
            const index = newValue.indexOf(e.target.value);
            if (index > -1) {
                newValue.splice(index, 1);
            }
        }
        onChange(name, newValue);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value.toLowerCase());
    };

    const filteredOptions = options.filter(option =>
        option.label.toLowerCase().includes(searchTerm)
    );

    const selectedLabels = options
        .filter(option => value.includes(option.value))
        .map(option => option.label)
        .join(', ');

    return (
        <div className='position-relative'>
            <div onClick={() => !disabled && setDropdownOpen(!dropdownOpen)} className="input-field cursor_pointer d-flex justify-content-between flex-wrap text-wrap" style={{ width: width }}>
                {selectedLabels.length > 0 ? selectedLabels : placeholder}
                <span><IoChevronDownSharp /></span>
            </div>
            {dropdownOpen && (
                <div className="dropdown-menu overflow-auto z-20" style={{ display: 'block', width: width, height: '15rem' }}>
                    <div className="mx-2 mb-1 position-sticky top-0">
                        <input
                            type="text"
                            className="input-field w-100"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={handleSearchChange}
                        />
                    </div>
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map((option) => (
                            <div key={option.value} className="form-check mx-2">
                                <input
                                    type="checkbox"
                                    className="form-check-input "
                                    id={option.value}
                                    value={option.value}
                                    onChange={handleCheckboxChange}
                                    checked={value.includes(option.value)}
                                    disabled={disabled}
                                />
                                <label title={option.label} className="form-check-label w-100 cursor_pointer text-truncate" htmlFor={option.value}>
                                    {option.label}
                                </label>
                            </div>
                        ))
                    ) : (
                        <div className="mx-2">No results found</div>
                    )}
                </div>
            )}
        </div>
    );
};

export default CustomCheckboxDropdown;
